import { all } from "redux-saga/effects";
import authSaga from "./auth/saga";
import fieldConfigSaga from "./fieldsConfig/saga";
import layoutSaga from "./layout/saga";
import financierUserSaga from "./financierUser/saga";
import currencySaga from "./currency/saga";
import baseRateSaga from "./baseRate/saga";
import holidaySaga from "./holiday/saga";
import branchSaga from "./branch/saga";
import helperSaga from "./helperData/saga";
import countrySaga from "./country/saga";
import stateSaga from "./state/saga";
import citySaga from "./city/saga";
import pincodeSaga from "./pincode/saga";
import relationshipManagerSaga from "./relationshipManager/saga";
import lovSaga from "./lov/saga";
import coLenderFinancierSaga from "./coLenderFinancier/saga";
import customerSaga from "./customer/saga";
import customerCICReportingSaga from './customerCICReporting/saga';
import PromoterDirectorsSaga from "./customerContact/saga";
import AddressSaga from "./customerAddress/saga";
import fetchCustomerCummunicationSaga from "./customerCummications/saga";
import productTypeSaga from "./productType/saga";
import limitConfigSaga from "./limitConfig/saga";
import CustomerBeneficiarySaga from "./customerBeneficary/saga";
import financingProgramSaga from "./financingPrograms/saga";
import productLimitConfigSaga from "./productLimitConfig/saga";
import buyerSellerSaga from "./buyerSeller/saga";
import CustomerBeneficiaryProgrammeSaga from "./customerBeneficaryProgrammme/saga";
import chargeSaga from "./charge/saga";
import instrumentBatchSaga from "./transaction/instrumentBatch/saga";
import instrumentSaga from "./transaction/instrument/saga";

import stagingBatchSaga from "./transaction/stagingBatch/saga";
import stagingInstrumentSaga from "./transaction/stagingInstrument/saga";

import paymentInstrumentSaga from "./transaction/paymentInstrument/saga";
import paymentBatchSaga from "./transaction/payment/saga";
import holidayBatchSaga from "./holidayBatch/saga";
import disbursementSaga from "./transaction/disbursement/saga";
import UserRoleSaga from "./userRoles/saga";
import eodBodSaga from "./eodBod/saga";
import instrumentInterestAccrualSaga from "./transaction/interestAccrual/saga";
import instrumentDailyBalanceSaga from "./transaction/dailyBalances/saga";
import RepaymentSaga from "./Repayment/repaymentRequest/saga";

import instrumentDailyBalanceHistorySaga from "./transaction/instrumentDailyBalancesHistory/saga";
import glAccountSaga from "./glAccount/saga";
import DisbursementSagaAuth from "./DisbursementAuth/saga";
import disbursementAdviceSaga from "./report/disbursementAdvice/saga";
import limitReportSaga from "./report/limitReport/saga";
import clientSummarySaga from "./report/clientSummary/saga";
import statementOfAccountsSaga from "./report/statementOfAccounts/saga";
import programmeSummarySaga from "./report/programmeSummary/saga";
import interestComputationSaga from "./report/interestComputation/saga";
import repaymentAdviceSaga from "./report/repaymentAdvice/saga";
import ExcessMoneySaga from "./Repayment/excessMoney/saga";
import ExcessRefundSaga from "./Repayment/excessRefund/saga";
import ExcessMoneySettlementSaga from "./Repayment/excessMoneySettlement/saga";
import ExcessMoneyRefundSaga from "./Repayment/excessMoneyRefund/saga";
import instrumentBatchUploadSaga from "./transaction/instrumentBatchUpload/saga";
import npaReportSaga from "./report/npaReport/saga";
import lifeCycleReportSaga from "./report/lifeCycleReport/saga";
import ChargeSettlementSaga from "./Repayment/chargeSettlement/saga";
import fundingDetailsSaga from "./report/fundingDetails/saga";
import RepaymentBulkInstrumentSaga from "./Repayment/repayment-intrument-bulk-request/saga";
import reportSaga from "./report/commonReports/saga";
import BulkCustomerSaga from "./bulkCustomer/saga";
import BulkCustomerCicReportingSaga from "./bulkCustomerCicReporting/saga";
import BulkBuyerSellerrSaga from "./bulkBuyerSeller/saga";
import BulkProgrammesFileSaga from "./bulkFinancingProgramme/saga";
import BulkLimitConfigFileSaga from "./bulkLimitConfig/saga";
import BulkBeneficiaryFileSaga from "./bulkBeneficiary/saga";
import payableChargeSaga from "./payableCharge/saga";
import overdueReportSaga from "./report/overdueReport/saga";
import integLogReportSaga from "./report/integLogReport.ts/saga";
import unrealisedIncomeReportSaga from "./report/unrealisedIncome/saga";
import oneViewReportSaga from "./report/oneViewReport/saga";
import chargeSummaryReportSaga from "./report/chargeSummary/saga";
import amortizationReportSaga from "./report/amortizationReport/saga";
import BuyerSellerDumpReportSaga from "./report/buyerSellerDump/saga";
import ProgrammesDumpReportSaga from "./report/programmesDump/saga";
import CustomerDumpReportSaga from "./report/customerDump/saga";
import limitConfigV2Saga from "./limitConfigV2/saga";
import crilicReportSaga from "./report/crilicReport/saga";
import systemParameterSaga from "./systemParameters/saga";
import dashboardSaga from "./dashboard/saga";

export default function* rootSaga() {
  yield all([
    authSaga(),
    fieldConfigSaga(),
    layoutSaga(),
    financierUserSaga(),
    currencySaga(),
    baseRateSaga(),
    holidaySaga(),
    branchSaga(),
    helperSaga(),
    countrySaga(),
    stateSaga(),
    citySaga(),
    pincodeSaga(),
    relationshipManagerSaga(),
    lovSaga(),
    coLenderFinancierSaga(),
    customerSaga(),
    BulkCustomerSaga(),
    BulkCustomerCicReportingSaga(),
    customerCICReportingSaga(),
    PromoterDirectorsSaga(),
    AddressSaga(),
    fetchCustomerCummunicationSaga(),
    productTypeSaga(),
    limitConfigSaga(),
    BulkLimitConfigFileSaga(),
    productLimitConfigSaga(),
    CustomerBeneficiarySaga(),
    financingProgramSaga(),
    BulkProgrammesFileSaga(),
    buyerSellerSaga(),
    BulkBuyerSellerrSaga(),
    BulkBeneficiaryFileSaga(),
    CustomerBeneficiaryProgrammeSaga(),
    chargeSaga(),
    payableChargeSaga(),
    instrumentBatchSaga(),
    instrumentBatchUploadSaga(),
    instrumentSaga(),
    stagingBatchSaga(),
    stagingInstrumentSaga(),
    paymentBatchSaga(),
    paymentInstrumentSaga(),
    holidayBatchSaga(),
    disbursementSaga(),
    UserRoleSaga(),
    eodBodSaga(),
    instrumentInterestAccrualSaga(),
    instrumentDailyBalanceSaga(),
    RepaymentSaga(),
    RepaymentBulkInstrumentSaga(),
    ExcessMoneySaga(),
    ExcessRefundSaga(),
    ExcessMoneySettlementSaga(),
    ExcessMoneyRefundSaga(),
    ChargeSettlementSaga(),

    instrumentDailyBalanceHistorySaga(),
    glAccountSaga(),
    DisbursementSagaAuth(),
    disbursementAdviceSaga(),
    limitReportSaga(),
    clientSummarySaga(),
    statementOfAccountsSaga(),
    interestComputationSaga(),
    repaymentAdviceSaga(),
    programmeSummarySaga(),
    npaReportSaga(),
    lifeCycleReportSaga(),
    fundingDetailsSaga(),
    reportSaga(),
    overdueReportSaga(),
    integLogReportSaga(),
    unrealisedIncomeReportSaga(),
    oneViewReportSaga(),
    chargeSummaryReportSaga(),
    amortizationReportSaga(),
    BuyerSellerDumpReportSaga(),
    ProgrammesDumpReportSaga(),
    CustomerDumpReportSaga(),
    limitConfigV2Saga(),
    crilicReportSaga(),
    systemParameterSaga(),
    dashboardSaga()
  ]);
}
